module.exports = __webpack_public_path__ + "media/images/icons/v2/refresh-cw-02-2783a803f3d1e51851181db718a461fb.svg";